import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jejdgbfw35: FaireBrandEntity = {
  token: "b_jejdgbfw35",
  type: "brand",
  name: "Twentifourth",
  avatarUrl:
    "https://cdn.faire.com/fastly/9ad29c34419cb1d61f28c118afbc8cab8c4d10d58a64e99b41cacfa4db79a5d3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/538a8aa77cdd18c8100f3992f96de33820eda8301f766d37c13af1e2ca423d42.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/9ad29c34419cb1d61f28c118afbc8cab8c4d10d58a64e99b41cacfa4db79a5d3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/538a8aa77cdd18c8100f3992f96de33820eda8301f766d37c13af1e2ca423d42.webp",
  location: "Vernon, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Twentifourth is a Los Angeles–based brand creating effortless, elevated essentials for the modern woman. Each collection is designed with cohesion in mind—tops and bottoms that mix and match seamlessly for easy, everyday styling. Versatile and timeless, our pieces are made to be worn season after season.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:48.271Z",
    importedBy: "entity-db-cli",
  },
};
